module.exports = __webpack_public_path__ + "img/security_burnt_fault.7016aedd.svg";